import { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge/dist/interfaces";
import { getBridgeSdk } from "./bridgeSdk";
import { mockSwgyHeaders } from "../tests/mock";

let swHeaders: GetSwiggyHeadersResponsePayload | undefined;

export const getSwiggyHeaders = async (): Promise<GetSwiggyHeadersResponsePayload | undefined> => {
    if (swHeaders) {
        return swHeaders;
    }

    if (process.env.NODE_ENV === "development") {
        swHeaders = mockSwgyHeaders;
        return mockSwgyHeaders;
    } else {
        swHeaders = await getBridgeSdk().getSwiggyHeadersFromClient();
    }

    return swHeaders;
};

export const getUserHeaders = () => {
    if (swHeaders) {
        return {
            tid: swHeaders.tid,
            sid: swHeaders.sid,
            deviceId: swHeaders.deviceId,
            token: swHeaders.token,
            ["version-code"]: swHeaders["version-code"],
        };
    }
};
